var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"loading":_vm.loading,"clearable":"","value":_vm.value,"items":_vm.items,"item-text":"title","item-value":"_id","label":"درامد متفرقه","rules":_vm.requiredRules,"no-data-text":"اطلاعاتی موجود نیست...","prepend-inner-icon":"mdi-cash-plus"},on:{"input":v => _vm.$emit('input', v)}})
}
var staticRenderFns = []

export { render, staticRenderFns }